import { Injectable } from "@angular/core";
import { UserModel } from "../models/entities/user.model";
import { BrowserStorageService } from "./browser-storage.service";
import { BehaviorSubject } from "rxjs";
import Constants from "../constants/constants";

@Injectable({
    providedIn: "root",
})
export class AuthService {
    currentUser$ = new BehaviorSubject<UserModel | null>(null);

    constructor(private storageService: BrowserStorageService) {}
    
    getCurrentUser$() {
        return this.currentUser$.asObservable();
    }

    isLoggedIn(): boolean {
        const user = this.storageService.getItem<UserModel>(
            Constants.UserStorageKey
        ) as UserModel;
        const isCompleted = !!(user?.email && user?.subscriptionId);
        if(isCompleted) this.currentUser$.next(user);
        return isCompleted;
    }

    isProfilCompleted(): boolean {
        const user = this.storageService.getItem<UserModel>(
            Constants.UserStorageKey
        ) as UserModel;
        return !!(user?.email && user?.subscriptionId);
    }

    login(user: UserModel, rememberMe: boolean = false): void {
        this.storageService.setItem(Constants.UserStorageKey, user, rememberMe);
    }

    getUserConnected(): UserModel {
        return this.storageService.getItem<UserModel>(Constants.UserStorageKey) as UserModel;
    }

    logout(): void {
        this.storageService.clear();
        this.currentUser$.next(null);
    }
}
